import './styles/style.scss';
import Nav from './Nav';

export default Nav;
